const doc = [({"courses":"Corsi", "downloads":"Prodotti digitali", "events":"Biglietti elettronici"})];
module.exports = doc.length <= 1 ? doc[0] : doc;